import React from 'react';

const MKPHyperLink = () => (
  <a href="https://mkpconnect.org/policy/mkp-usa-holacracy-based-operating-system">
    MKP USA Operating System Constitution
  </a>
);

export default MKPHyperLink;
